export const firmClientMutationKeys = {
  updateClientSpendingService: ['updateClientSpendingService'],
};
